exports.typeofArray = require('./typeofUtil').typeofArray;
exports.typeofFunction = require('./typeofUtil').typeofFunction;
exports.typeofObject = require('./typeofUtil').typeofObject;
exports.typeofString = require('./typeofUtil').typeofString;
exports.typeofPrototype = require('./typeofUtil').typeofPrototype;

exports.SetSingleCookie2 = require('./cookieUtil').SetSingleCookie2;
exports.SetSingleCookieV2 = require('./cookieUtil').SetSingleCookieV2;
exports.GetSingleCookieV2 = require('./cookieUtil').GetSingleCookieV2;
exports.FixNum = require('./handleNumUtil').FixNum;

exports.cookieMatch = require('./cookieUtil').GetSingleCookieMatch;
exports.cookieSet = require('./cookieUtil').SetSingleCookie;
exports.cookieGet = require('./cookieUtil').GetSingleCookie;

exports.isClient = require('./isClientUtil').isClient;

exports.GoogleTagManagerV2 = require('./googleTagManagerUtil').GoogleTagManager;
exports.pushGoogleTagManagerV2 = require('./googleTagManagerUtil').pushGoogleTagManager;
exports.pushUserInformationGoogleTagManager = require('./googleTagManagerUtil').pushUserInformationGoogleTagManager;
exports.getKeyWordByUrl = require('./googleTagManagerUtil').getKeyWordByUrl;

exports.appendScript = require('./appendFilesUtil').appendScript;
exports.appendStyleSheets = require('./appendFilesUtil').appendStyleSheets;

exports.createNumArray = require('./timeUtil').createNumArray;
exports.isLeapYear = require('./timeUtil').isLeapYear;
exports.createMonthsArr = require('./timeUtil').createMonthsArr;
exports.createDaysArr = require('./timeUtil').createDaysArr;



// WEBPACK FOOTER //
// ./common/Utils/index.js